import {
  GET_GROUPS,
  SET_GROUPS,
  CREATE_GROUPS,
  CREATED_GROUPS,
  RESET_GROUPS,
  API_ERROR,
  GET_GROUP,
  SET_GROUP,
  EDIT_GROUP,
  EDIT_GROUP_SUCCESS,
  DELETE_GROUP,
  DELETE_GROUP_SUCCESS,
} from "./actionTypes";

export const resetGroups = () => {
  return {
    type: RESET_GROUPS,
    payload: {},
  };
};

export const getGroups = (page, qnt, name) => {
  return {
    type: GET_GROUPS,
    payload: { page, qnt, name },
  };
};

export const loadGroups = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_GROUPS,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createGroup = (newGroupValues) => {
  return {
    type: CREATE_GROUPS,
    payload: { newGroupValues },
  };
};

export const createdGroup = (newGroupValues, message) => {
  return {
    type: CREATED_GROUPS,
    payload: { newGroupValues, message },
  };
};

export const getGroup = (idGroup, isForm) => {
  return {
    type: GET_GROUP,
    payload: { idGroup, isForm },
  };
};

export const setGroup = (data) => {
  return {
    type: SET_GROUP,
    payload: { data },
  };
};

export const editGroup = (idGroup, newGroupValues) => {
  return {
    type: EDIT_GROUP,
    payload: { idGroup, newGroupValues },
  };
};

export const editGroupSuccess = (newGroupValues, message) => {
  return {
    type: EDIT_GROUP_SUCCESS,
    payload: { newGroupValues, message },
  };
};

export const deleteGroup = (idGroup) => {
  return {
    type: DELETE_GROUP,
    payload: { idGroup },
  };
};

export const deleteGroupSuccess = (idGroup, message) => {
  return {
    type: DELETE_GROUP_SUCCESS,
    payload: { idGroup, message },
  };
};
